module.exports = {"pathContext":{}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/terms-of-service.json
// module id = 350
// module chunks = 227998926125147